import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Play, Star, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";

interface GameData {
  id: string;
  title: string;
  provider: string;
  image: string;
  rating: number;
  category: string;
  description: string;
  game_url?: string;
  // Campos adicionais para esportes
  date?: string;
  time?: string;
  oddsHome?: number;
  oddsDraw?: number | null;
  oddsAway?: number;
  // Campos adicionais para cassino ao vivo
  dealer?: string;
}

const FeaturedGames = () => {
  const [featuredGames, setFeaturedGames] = useState<GameData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchGames = async () => {
      setLoading(true);
      setError(null);
      /*
      try {
        const response = await fetch("https://slots.virtualebank.com.br/games");
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || `Failed to fetch games: ${response.status}`);
        }
        const data: GameData[] = await response.json();
        // Para fins de demonstração, pegamos os 4 primeiros jogos como destaque
        setFeaturedGames(data.slice(0, 4));
      } catch (err) {
        console.error("Error fetching featured games:", err);
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }*/
    };

    fetchGames();
  }, []);

  if (loading) {
    return (
      <section className="py-16 md:py-24 bg-secondary/30 flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-primary" />
        <p className="ml-3 text-lg text-foreground">Carregando jogos em destaque...</p>
      </section>
    );
  }

  if (error) {
    return (
      <section className="py-16 md:py-24 bg-secondary/30 text-center text-red-500">
        <p>Erro ao carregar jogos em destaque: {error}</p>
      </section>
    );
  }

  return (
    <section className="py-16 md:py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Jogos em Destaque
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Os jogos mais populares e com maiores prêmios
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredGames.map((game, index) => (
            <Link
              to={`/game/${game.id}`}
              key={index}
            >
              <Card
                className="group relative overflow-hidden border-border hover:border-primary/50 transition-all duration-300 hover:shadow-card cursor-pointer animate-fade-in h-full"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardContent className="p-0">
                  {/* Game Image */}
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={game.image}
                      alt={game.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    
                    {/* Play Button Overlay */}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center shadow-glow">
                        <Play className="w-7 h-7 text-primary-foreground ml-1" fill="currentColor" />
                      </div>
                    </div>

                    {/* Badge (pode ser adaptado se o backend fornecer) */}
                    <div className="absolute top-3 left-3">
                      <Badge className="bg-accent text-accent-foreground font-semibold">
                        {game.category}
                      </Badge>
                    </div>

                    {/* Rating */}
                    <div className="absolute top-3 right-3 bg-background/90 backdrop-blur-sm rounded-full px-2 py-1 flex items-center space-x-1">
                      <Star className="w-3 h-3 text-accent fill-accent" />
                      <span className="text-xs font-semibold text-foreground">{game.rating}</span>
                    </div>
                  </div>

                  {/* Game Info */}
                  <div className="p-4">
                    <div className="text-xs text-primary font-medium mb-1">
                      {game.provider}
                    </div>
                    <h3 className="text-lg font-bold text-foreground group-hover:text-primary transition-colors">
                      {game.title}
                    </h3>
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>

        {/* Load More Button */}
        <div className="text-center mt-12">
          <Link to="/casino">
            <button className="px-8 py-3 bg-card border border-border hover:border-primary/50 rounded-lg text-foreground font-medium hover:text-primary transition-all duration-300">
              Ver Todos os Jogos
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedGames;